import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { createUseStyles } from 'react-jss';
import cx from 'classnames';
import { Form, Formik } from 'formik';
import { withTheme } from 'theming';
import { mergeStyles } from '../../utils/StyleUtils';
import withMemo from '../../decorators/withMemo';
import { compileInitialValues } from '../../helpers/FormHelpers';
import { validateAll } from '../../helpers/ValidationHelpers';
import { useSafeCall } from '../../helpers/React';
import Submit from '../form/Submit';
import A from '../A';
import BackLink from '../BackLink';
import FormGenerator from '../FormGenerator';
import styles from './styles';
var useStyles = createUseStyles(styles);
var FormForgotten = function FormForgotten(props) {
  var classesProp = props.classes,
    className = props.className,
    initialValues = props.initialValues,
    fieldsProps = props.fieldsProps,
    messages = props.messages,
    onSubmit = props.onSubmit,
    forgottenLinkProps = props.forgottenLinkProps,
    forgottenLinkLabel = props.forgottenLinkLabel,
    backLinkProps = props.backLinkProps,
    backLinkLabel = props.backLinkLabel,
    submitErrors = props.submitErrors,
    submitLabel = props.submitLabel,
    submitPendingLabel = props.submitPendingLabel,
    submitPending = props.submitPending,
    submitSuccess = props.submitSuccess,
    submitSuccessLabel = props.submitSuccessLabel,
    sections = props.sections,
    fields = props.fields,
    rules = props.rules;
  var classesComp = useStyles(props);
  var classes = useMemo(function () {
    return mergeStyles(classesComp, classesProp);
  }, [classesProp, classesComp]);

  // handlers
  var handleValidate = useCallback(function (values) {
    return validateAll(values, rules, messages);
  }, [messages, rules]);
  var handleSubmit = useSafeCall(onSubmit);
  var renderForm = function renderForm(formikProps) {
    return /*#__PURE__*/React.createElement(Form, {
      noValidate: true,
      autoComplete: "off",
      onSubmit: formikProps.handleSubmit,
      className: classes.form
    }, /*#__PURE__*/React.createElement(FormGenerator, {
      sections: sections,
      formikProps: formikProps,
      fieldsProps: fieldsProps
    }), submitErrors && /*#__PURE__*/React.createElement("ul", {
      className: classes.formErrors
    }, submitErrors.map(function (error, i) {
      return /*#__PURE__*/React.createElement("li", {
        className: classes.error,
        key: i
      }, (error == null ? void 0 : error.label) || (error == null ? void 0 : error.message));
    })), forgottenLinkProps && /*#__PURE__*/React.createElement("div", {
      className: classes.forgotten
    }, /*#__PURE__*/React.createElement(A, forgottenLinkProps, forgottenLinkLabel)), /*#__PURE__*/React.createElement("div", {
      className: classes.formActions
    }, /*#__PURE__*/React.createElement(Submit, {
      label: submitLabel,
      className: classes.formSubmit,
      pendingLabel: submitPendingLabel,
      isDisabled: !formikProps.dirty,
      isPending: submitPending,
      isSuccess: !formikProps.dirty && submitSuccess,
      successLabel: submitSuccessLabel
    })), backLinkProps && /*#__PURE__*/React.createElement("div", {
      className: classes.backLink
    }, /*#__PURE__*/React.createElement(BackLink, backLinkProps, backLinkLabel)));
  };
  return /*#__PURE__*/React.createElement("div", {
    className: cx(classes.container, className)
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.wrapper
  }, /*#__PURE__*/React.createElement(Formik, {
    enableReinitialize: true,
    validate: handleValidate,
    onSubmit: handleSubmit,
    initialValues: compileInitialValues(fields, initialValues)
  }, renderForm)));
};
FormForgotten.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.objectOf(PropTypes.string),
  // eslint-disable-next-line react/forbid-prop-types
  initialValues: PropTypes.object,
  fieldsProps: PropTypes.objectOf(PropTypes.shape({
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    help: PropTypes.string,
    placeholder: PropTypes.string,
    options: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string,
      value: PropTypes.string
    }))
  })),
  messages: PropTypes.objectOf(PropTypes.string),
  onSubmit: PropTypes.func,
  submitPending: PropTypes.bool,
  submitPendingLabel: PropTypes.string,
  submitSuccess: PropTypes.bool,
  submitSuccessLabel: PropTypes.string,
  submitLabel: PropTypes.string,
  submitErrors: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    label: PropTypes.string,
    field: PropTypes.string
  })),
  backLinkProps: PropTypes.shape(A.propTypes),
  backLinkLabel: PropTypes.string,
  forgottenLinkProps: PropTypes.shape(A.propTypes),
  forgottenLinkLabel: PropTypes.string,
  sections: FormGenerator.propTypes.sections,
  fields: PropTypes.arrayOf(PropTypes.object),
  rules: PropTypes.objectOf(PropTypes.string)
};
FormForgotten.defaultProps = {
  className: null,
  classes: {},
  initialValues: null,
  fieldsProps: null,
  messages: null,
  onSubmit: function onSubmit() {
    return null;
  },
  submitPending: false,
  submitPendingLabel: null,
  submitSuccess: false,
  submitSuccessLabel: null,
  submitLabel: null,
  submitErrors: null,
  backLinkProps: null,
  backLinkLabel: '',
  forgottenLinkProps: null,
  forgottenLinkLabel: '',
  sections: null,
  fields: null,
  rules: null
};
export default withMemo()(withTheme(FormForgotten));